var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5703 0.929688V7.78683H20.4275M20.4275 21.5011C20.4275 21.9557 20.2468 22.3919 19.9253 22.7133C19.6039 23.0347 19.1678 23.2154 18.7132 23.2154H3.2846C2.82994 23.2154 2.39391 23.0347 2.07241 22.7133C1.75093 22.3919 1.57031 21.9557 1.57031 21.5011V2.64397C1.57031 2.18931 1.75093 1.75328 2.07241 1.43179C2.39391 1.1103 2.82994 0.929688 3.2846 0.929688H14.4275L20.4275 6.92969V21.5011Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification2);
export default __webpack_public_path__ + "static/media/notification2.a7b6164cd4189cee3d82ec13c9dbc0d0.svg";
export { ForwardRef as ReactComponent };